import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";

@Entity({many: "tags"})
class Tag {
	@Field()
	public id: any;

	@Field()
	public name: string;
}

const tagSelect = EntitySelect.registered({entity: Tag, type: 'many'}, 'string');

// EntityMultiSelect.registered(Tag, {}, {lazyLoad: true});

const eventDetailsLocationSelect = ButtonSelect.registerWithOptions([
	{ value: "redirect", label: "Redirect to Details Page"},
	{ value: "dialog", label: "Dialog" }
]);

@Form({title: "Bundle Entries Calendar Config"})
export default class BundleEntriesCalendarConfig {

	@Input({type: eventDetailsLocationSelect, title: "Selected Course Details Display"})
	public detailsType?: "redirect" | "dialog";

	@Input({type: InputType.PAGE_PATH, title: "Details Page"})
	public detailsPage?: string[];

	@Input({type: tagSelect, title: "Filter By Tags"})
	public tags?: any[];

	@Input({type: InputType.CHECKBOX, title: "Tag \"OR\" Condition"})
	public tagOrCondition?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Language Support Enabled"})
	public enableLanguageSupport?: boolean;

	@Input({type: InputType.JSON, title: "Parameters"})
	public params: object;

}



// WEBPACK FOOTER //
// ./src/panels/entriesCalendar/BundleEntriesCalendarConfig.ts